/* eslint-disable max-len */
import { LANGUAGE_KEY } from './language.constants';

const en: Record<LANGUAGE_KEY, string> = {
  [LANGUAGE_KEY.ENTRY_EXCEEDS_LENGTH_LIMIT]: 'Entry exceeds length limit',
  [LANGUAGE_KEY.SHERPATH_AI_MATERIALS_LABEL]: 'Your materials',
  [LANGUAGE_KEY.SHERPATH_AI_EBOOK_LABEL]: 'eBook',
  [LANGUAGE_KEY.VALUE_REQUIRED]: 'Value required',
};

export default en;
